/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { unsetUserData } from '../../user/actions';
import { AmbientModeSettings } from './types';

const initialState: AmbientModeSettings = {
  shouldSkipOnboardingPrompt: false,
};

const ambientModeSlice = createSlice({
  name: 'ambientMode',
  initialState,
  reducers: {
    setLastSelectedBackgroundMusicURL: (state, { payload }: PayloadAction<string>) => {
      state.lastSelectedBackgroundMusicURL = payload;
    },
    setShouldSkipOnboardingPrompt: (state, { payload }: PayloadAction<boolean>) => {
      state.shouldSkipOnboardingPrompt = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(unsetUserData, () => initialState);
  },
});

export default ambientModeSlice;
